<template>
	<div id="wrap">
		<div class="flex flex-justify">
			<div>
				<el-button type="primary" @click="yearQuery(years[0])">{{
					years[0]
				}}</el-button>
				<el-button type="primary" @click="yearQuery(years[1])">{{
					years[1]
				}}</el-button>
				<el-button type="primary" @click="yearQuery(years[2])">{{
					years[2]
				}}</el-button>
			</div>
			<div>
				<el-button type="primary" @click="handleAdd">新增</el-button>
			</div>
		</div>

		<el-dialog
			title="企业年度研究开发费用结构明细表"
			:visible.sync="centerDialogVisible"
			width="80%"
			center
		>
			<div>
				<div class="content">
					<el-form
						:model="formData"
						:rules="rules"
						ref="formData"
						class="demo-ruleForm"
					>
						<el-row type="flex" class="row-bg" justify="space-between">
							<el-col :span="11">
								<el-form-item
									label="项目编号"
									prop="projectNumber"
									label-width="45%"
								>
									<el-input
										:maxlength="inputMax"
										v-model="formData.projectNumber"
										placeholder="请填写"
									></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="11">
								<el-form-item label="年度" prop="annual" label-width="45%">
									<!--                <el-input-number-->
									<!--                  :controls="false"-->
									<!--                  v-model="formData.annual"-->
									<!--                  placeholder="请填写"-->
									<!--                ></el-input-number>-->
									<el-select v-model="formData.annual">
										<el-option
											v-for="dict in years"
											:key="dict"
											:value="dict"
											:label="dict"
										>
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="11">
								<el-form-item
									label="内部研究开发费用"
									prop="internalResearchCost"
									label-width="45%"
								>
									<el-input-number
										:max="9999999999999999"
										:controls="false"
										v-model="formData.internalResearchCost"
										placeholder="请填写"
									></el-input-number>
								</el-form-item>
							</el-col>

							<el-col :span="11">
								<el-form-item
									label="人员人工费用"
									prop="labourCharges"
									label-width="45%"
								>
									<el-input-number
										:max="9999999999999999"
										:controls="false"
										v-model="formData.labourCharges"
										placeholder="请填写"
									></el-input-number>
								</el-form-item>
							</el-col>

							<el-col :span="11">
								<el-form-item
									label="直接投入费用"
									prop="directInputCharges"
									label-width="45%"
								>
									<el-input-number
										:max="9999999999999999"
										:controls="false"
										v-model="formData.directInputCharges"
										placeholder="请填写"
									></el-input-number>
								</el-form-item>
							</el-col>

							<el-col :span="11">
								<el-form-item
									label="折旧费用与长期待摊费用"
									prop="depreciationCharges"
									label-width="45%"
								>
									<el-input-number
										:max="9999999999999999"
										:controls="false"
										v-model="formData.depreciationCharges"
										placeholder="请填写"
									></el-input-number>
								</el-form-item>
							</el-col>

							<el-col :span="11">
								<el-form-item
									label="设计费用"
									prop="designCharges"
									label-width="45%"
								>
									<el-input-number
										:max="9999999999999999"
										:controls="false"
										v-model="formData.designCharges"
										placeholder="请填写"
									></el-input-number>
								</el-form-item>
							</el-col>
							<el-col :span="11">
								<el-form-item
									label="无形资产摊销费用"
									prop="intangibleAmortization"
									label-width="45%"
								>
									<el-input-number
										:max="9999999999999999"
										:controls="false"
										v-model="formData.intangibleAmortization"
										placeholder="请填写"
									></el-input-number>
								</el-form-item>
							</el-col>
							<el-col :span="11">
								<el-form-item
									label="企业填报人"
									prop="enterpriseApplicant"
									label-width="45%"
								>
									<el-input
										:maxlength="inputMax"
										v-model="formData.enterpriseApplicant"
										placeholder="请填写"
									></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="11">
								<el-form-item
									label="企业填报人签字日期"
									prop="enterpriseApplicantSignature"
									label-width="45%"
								>
									<el-date-picker
										:editable="false"
										value-format="yyyy-MM-dd"
										:picker-options="pickerOptions"
										v-model="formData.enterpriseApplicantSignature"
										placeholder="请填写"
									></el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="11">
								<el-form-item
									label="装备调试费用与试验费用"
									prop="equipmentCommissionCharges"
									label-width="45%"
								>
									<el-input-number
										:max="9999999999999999"
										:controls="false"
										v-model="formData.equipmentCommissionCharges"
										placeholder="请填写"
									></el-input-number>
								</el-form-item>
							</el-col>

							<el-col :span="11">
								<el-form-item
									label="其他费用"
									prop="otherCharges"
									label-width="45%"
								>
									<el-input-number
										:max="9999999999999999"
										:controls="false"
										v-model="formData.otherCharges"
										placeholder="请填写"
									></el-input-number>
								</el-form-item>
							</el-col>
							<el-col :span="11">
								<el-form-item
									label="委托外部研究开发费用"
									prop="commissionedExternalResearchCharges"
									label-width="45%"
								>
									<el-input-number
										:max="9999999999999999"
										:controls="false"
										v-model="formData.commissionedExternalResearchCharges"
										placeholder="请填写"
									></el-input-number>
								</el-form-item>
							</el-col>
							<el-col :span="11">
								<el-form-item
									label="境内的外部研究开发费用"
									prop="cisborderExternalCharges"
									label-width="45%"
								>
									<el-input-number
										:max="9999999999999999"
										:controls="false"
										v-model="formData.cisborderExternalCharges"
										placeholder="请填写"
									></el-input-number>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false">返回</el-button>
				<el-button type="primary" @click="classSubmitForm">保存</el-button>
			</span>
		</el-dialog>

		<el-table
			class="table"
			:data="datas"
			v-loading="loading"
			:header-cell-style="{ background: '#F5F7FA' }"
			stripe
			:row-class-name="tableRowClassName"
		>
			<el-table-column label="序号" align="center">
				<template slot-scope="scope">
					<span>{{ scope.$index + 1 }}</span>
				</template>
			</el-table-column>
			<el-table-column
				label="项目编号"
				prop="projectNumber"
				align="center"
			></el-table-column>
			<el-table-column
				prop="internalResearchCost"
				label="内部研究开发费用"
				align="center"
			>
			</el-table-column>
			<el-table-column
				prop="labourCharges"
				label="人员员工费用"
				align="center"
			></el-table-column>
			<el-table-column
				label="直接投入费用"
				prop="directInputCharges"
				align="center"
			></el-table-column>
			<el-table-column
				label="折旧费用与长期待摊费用"
				prop="depreciationCharges"
				align="center"
			></el-table-column>
			<el-table-column
				label="无形资产摊销费用"
				prop="intangibleAmortization"
				align="center"
			></el-table-column>
			<el-table-column
				label="设计费用"
				prop="designCharges"
				align="center"
			></el-table-column>
			<el-table-column label="操作" align="center">
				<template slot-scope="scope">
					<el-button
						type="text"
						size="small"
						class="green"
						@click="handleUpdate(scope.row.id)"
						>编辑</el-button
					>
					<el-button
						type="text"
						size="small"
						class="red"
						@click="handleDelete(scope.row.id)"
						>删除</el-button
					>
				</template>
			</el-table-column>
		</el-table>
		<div class="flex flex-end">
			<el-pagination
				class="pagination"
				background
				v-show="total > 0"
				:total="total"
				:current-page.sync="queryParams.pageNum"
				:page-size.sync="queryParams.pageSize"
				@current-change="getList"
			>
			</el-pagination>
		</div>
	</div>
</template>

<script>
import {
	annualCostQueryAll,
	annualCostQuery,
	annualCostSave,
	annualCostDelete
} from "@/api/ChinaHigh";
import { getLastThreeYears } from "@/api/specialization";
export default {
	name: "structure",
	props: {
		id: {
			type: String,
			default: ""
		}
	},
	data() {
		return {
			// 数据
			datas: [],
			total: 0,
			loading: true,
			// 弹框
			centerDialogVisible: false,
			queryParams: {
				annual: ""
			},
			formData: {},
			rules: {
				projectNumber: [
					{ required: true, message: "请输入项目编号", trigger: "blur" }
				],
				annual: [{ required: true, message: "请选择年度", trigger: "change" }],
				internalResearchCost: [
					{ required: true, message: "请输入内部研究开发费用", trigger: "blur" }
				],
				labourCharges: [
					{ required: true, message: "请输入人员人工费用", trigger: "blur" }
				],
				directInputCharges: [
					{ required: true, message: "请输入直接投入费用", trigger: "blur" }
				],
				depreciationCharges: [
					{
						required: true,
						message: "请输入折旧费用与长期待摊费用",
						trigger: "blur"
					}
				],
				designCharges: [
					{ required: true, message: "请输入设计费用", trigger: "blur" }
				],
				intangibleAmortization: [
					{ required: true, message: "请输入无形资产摊销费用", trigger: "blur" }
				],
				enterpriseApplicant: [
					{ required: true, message: "请输入企业填报人", trigger: "blur" },
					{
						pattern: /[\u4e00-\u9fa5]/,
						message: "只可以输入汉字哦！",
						trigger: "blur"
					}
				],
				enterpriseApplicantSignature: [
					{
						required: true,
						message: "请选择企业填报人签字日期",
						trigger: "blur"
					}
				],
				equipmentCommissionCharges: [
					{
						required: true,
						message: "请输入装备调试费用与试验费用",
						trigger: "blur"
					}
				],
				cisborderExternalCharges: [
					{
						required: true,
						message: "请输入境内的外部研究开发费用",
						trigger: "blur"
					}
				]
			},
			//日期限制
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now() - 8.64e6;
				}
			},
			years: []
		};
	},
	created() {
		this.handleQuery();
		this.init();
	},
	methods: {
		init() {
			getLastThreeYears().then(res => {
				this.years = res.data;
			});
		},
		tableRowClassName({ row, rowIndex }) {
			if ((rowIndex + 1) % 2 === 0) {
				return "background:#fff";
			} else {
				return "background:#F5F7FA";
			}
		},
		/** 搜索按钮操作 */
		handleQuery() {
			this.queryParams.approvalId = this.id;
			this.queryParams.pageNum = 1;
			this.queryParams.pageSize = 10;
			this.getList();
		},
		yearQuery(year) {
			console.log(year);
			this.queryParams.approvalId = this.id;
			this.queryParams.year = year;
			annualCostQueryAll(this.queryParams).then(res => {
				console.log(res);
			});
			this.getList();
		},
		/** 列表 */
		getList() {
			this.loading = true;
			annualCostQueryAll(this.queryParams).then(res => {
				this.datas = res.data.records;
				this.total = res.data.total;
				this.loading = false;
			});
		},
		chushi() {
			this.formData = {};
			this.resetForm("formData");
		},
		handleAdd() {
			this.chushi();
			this.centerDialogVisible = true;
		},
		handleUpdate(id) {
			this.chushi();
			annualCostQuery(id).then(res => {
				console.log(res);
				this.formData = res.data;
				this.centerDialogVisible = true;
			});
		},
		classSubmitForm() {
			this.formData.approvalId = this.id;
			this.$refs["formData"].validate(valid => {
				if (valid) {
					annualCostSave(this.formData).then(res => {
						if (res.code === "00000") {
							this.handleQuery();
							this.centerDialogVisible = false;
							this.msgSuccess(res.msg);
						}
					});
				} else {
					return false;
				}
			});
		},
		handleDelete(id) {
			var that = this;
			this.$confirm("是否确认删除研发开发费用吗?", "警告", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(function() {
					return annualCostDelete({ approvalId: that.id, ids: [id] });
				})
				.then(() => {
					this.getList();
					this.msgSuccess("删除成功");
				})
				.catch(function() {});
		}
	}
};
</script>

<style scoped>
.flex .el-button {
	margin-bottom: 10px;
}
.button_box {
	margin-top: 20px;
}
.button_box button {
	padding: 10px 60px;
}
.image {
	width: 100%;
	height: auto;
}
.select_box {
	display: flex;
	justify-content: space-between;
}
.select_box .el-select {
	width: 30% !important;
}
.textarea {
	width: 90%;
	height: 164px;
	border: 1px solid #dcdfe6;
	border-radius: 4px;
	resize: none;
}

.wrap {
	width: 84%;
	margin-left: 16%;
}

.row-bg {
	width: 84%;
	margin: 0 auto;
	flex-wrap: wrap;
}

.content {
	margin-top: 30px;
	background: #fff;
	width: 100%;
}
.content .text {
	font-size: 13px;
	padding: 10px 20px;
	border-bottom: 1px solid #d4d4d4;
	position: relative;
}
.accessory_box {
	width: 100%;
}
.accessory_box > div {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 10px 0;
}

.content .text::before {
	content: "";
	position: absolute;
	width: 4px;
	height: 18px;
	left: 10px;
	top: 10px;
	background: #7c99fd;
}
.el-table .cell {
	white-space: pre-line;
}
.el-select {
	width: 100%;
}
</style>
